"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isWidthUp = exports.isWidthDown = exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _getDisplayName = _interopRequireDefault(require("@mui/utils/getDisplayName"));
var _useThemeProps = require("@mui/system/useThemeProps");
var _useTheme = _interopRequireDefault(require("../styles/useTheme"));
var _useEnhancedEffect = _interopRequireDefault(require("../utils/useEnhancedEffect"));
var _useMediaQuery = _interopRequireDefault(require("../useMediaQuery"));
var _jsxRuntime = require("react/jsx-runtime");
var breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
// By default, returns true if screen width is the same or greater than the given breakpoint.
var isWidthUp = function(breakpoint, width) {
    var inclusive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (inclusive) {
        return breakpointKeys.indexOf(breakpoint) <= breakpointKeys.indexOf(width);
    }
    return breakpointKeys.indexOf(breakpoint) < breakpointKeys.indexOf(width);
};
// By default, returns true if screen width is less than the given breakpoint.
exports.isWidthUp = isWidthUp;
var isWidthDown = function(breakpoint, width) {
    var inclusive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (inclusive) {
        return breakpointKeys.indexOf(width) <= breakpointKeys.indexOf(breakpoint);
    }
    return breakpointKeys.indexOf(width) < breakpointKeys.indexOf(breakpoint);
};
exports.isWidthDown = isWidthDown;
var withWidth = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Component) {
        var WithWidth = function WithWidth(props) {
            var contextTheme = (0, _useTheme.default)();
            var theme = props.theme || contextTheme;
            var _ref = (0, _useThemeProps.getThemeProps)({
                theme: theme,
                name: 'MuiWithWidth',
                props: props
            }), initialWidth = _ref.initialWidth, width = _ref.width, other = _object_without_properties(_ref, [
                "initialWidth",
                "width"
            ]);
            var _React_useState = _sliced_to_array(React.useState(false), 2), mountedState = _React_useState[0], setMountedState = _React_useState[1];
            (0, _useEnhancedEffect.default)(function() {
                setMountedState(true);
            }, []);
            /**
     * innerWidth |xs      sm      md      lg      xl
     *            |-------|-------|-------|-------|------>
     * width      |  xs   |  sm   |  md   |  lg   |  xl
     */ var keys = theme.breakpoints.keys.slice().reverse();
            var widthComputed = keys.reduce(function(output, key) {
                // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
                // eslint-disable-next-line react-hooks/rules-of-hooks
                var matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
                return !output && matches ? key : output;
            }, null);
            var more = _object_spread({
                width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
            }, withThemeOption ? {
                theme: theme
            } : {}, other);
            // When rendering the component on the server,
            // we have no idea about the client browser screen width.
            // In order to prevent blinks and help the reconciliation of the React tree
            // we are not rendering the child component.
            //
            // An alternative is to use the `initialWidth` property.
            if (more.width === undefined) {
                return null;
            }
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, _object_spread({}, more));
        };
        var tmp = options.withTheme, withThemeOption = tmp === void 0 ? false : tmp, _options_noSSR = options.noSSR, noSSR = _options_noSSR === void 0 ? false : _options_noSSR, initialWidthOption = options.initialWidth;
        process.env.NODE_ENV !== "production" ? WithWidth.propTypes = {
            /**
     * As `window.innerWidth` is unavailable on the server,
     * we default to rendering an empty component during the first mount.
     * You might want to use a heuristic to approximate
     * the screen width of the client browser screen width.
     *
     * For instance, you could be using the user-agent or the client-hints.
     * https://caniuse.com/#search=client%20hint
     */ initialWidth: _propTypes.default.oneOf([
                'xs',
                'sm',
                'md',
                'lg',
                'xl'
            ]),
            /**
     * @ignore
     */ theme: _propTypes.default.object,
            /**
     * Bypass the width calculation logic.
     */ width: _propTypes.default.oneOf([
                'xs',
                'sm',
                'md',
                'lg',
                'xl'
            ])
        } : void 0;
        if (process.env.NODE_ENV !== 'production') {
            WithWidth.displayName = "WithWidth(".concat((0, _getDisplayName.default)(Component), ")");
        }
        return WithWidth;
    };
};
var _default = exports.default = withWidth;
